<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    full-width
    transition="none"
  >
    <v-container
      bg
      fluid
      fill-height
      class="maintenance"
      text-xs-center
    >
      <v-layout
        justify-center
        align-center
      >
        <v-card flat>
          <v-card-text>
            <div class="mt-3 mb-3 white">
              <img
                :src="maintenanceImg"
                style="max-height: 380px;"
              />
            </div>
            <span v-if="restaurants && restaurants.length > 1">
              <p>... see other <router-link :to="{ name: 'outlets' }">outlets</router-link></p>
            </span>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'maintenance',
  layout: 'common',
  data: () => ({
    dialog: true
  }),
  computed: {
    ...mapGetters('config', [
      'restaurants'
    ]),
    maintenanceImg() {
      return window.config.sharedPictures + 'maintenance.png'
    }
  }
}
</script>

<style scoped>
.maintenance {
  background-color: white;
}
.important-note {
  text-transform: uppercase;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Maintenance.vue